import { render } from "./AdminViewPendingRequest.vue?vue&type=template&id=abb871dc"
import script from "./AdminViewPendingRequest.vue?vue&type=script&lang=js"
export * from "./AdminViewPendingRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__